import { FC } from 'react';
import { Modal as QcsModal, useTheme } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import { GridList } from '../../../common/grid/GridList';
import { QcsTableCell } from '../../../common/basic/QcsTableCell';
import { useTranslation } from 'react-i18next';
import { getLangNameObj } from '../../../../utils/format';
import { SafetyEquipmentType } from '@api/models/enums/SafetyEquipmentType';
import { SafetyEquipmentDto } from '@api/models/invitation/SafetyEquipmentDto';
import { InvitationRelationResponse } from '@api/models/invitation/InvitationRelationResponse';

interface Props {
  item?: InvitationRelationResponse;
  onClose: () => void;
}

export const WorkplaceSafetyEquipmentModal: FC<Props> = ({ item, onClose }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const handleRenderData = (item: SafetyEquipmentDto) => {
    return (
      <>
        <QcsTableCell>{getLangNameObj(i18n, item)}</QcsTableCell>
        <QcsTableCell
          sx={{
            color: item.type === SafetyEquipmentType.Owned ? theme.palette.warning.main : undefined,
          }}
        >
          {t('safetyEquipment.types.' + item.type)}
        </QcsTableCell>
      </>
    );
  };

  return (
    <QcsModal open={!!item} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="invitation.workplace.safetyEquipmentTitle" />
        <GridList<SafetyEquipmentDto>
          headers={[
            { captionStr: 'invitation.workplace.safetyEquipmentName' },
            { captionStr: 'invitation.workplace.safetyEquipmentType' },
          ]}
          data={item?.safetyEquipments ?? []}
          renderData={handleRenderData}
          search={false}
          hidePagination={true}
        />
      </QcsModalBox>
    </QcsModal>
  );
};
